import { render, staticRenderFns } from "./XmlMonthly.vue?vue&type=template&id=2f433973"
import script from "./XmlMonthly.vue?vue&type=script&lang=js"
export * from "./XmlMonthly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports